// extracted by mini-css-extract-plugin
module.exports = {"carPackageOuter":"_38ZOy","carPackageHeading":"_17MxV","carPackageSubHeading":"_1urPu","sliderWrapper":"_3NSmg","rightGradient":"_2zh5n"};